import type { FilterRuleModel } from '@/shared/generated'

import { ChevronDownIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/shared/components/ui/button'
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from '@/shared/components/ui/popover'
import { useDisclosure } from '@/shared/hooks/use-disclosure'

import { OptimizationsActions } from './OptimizationsActions'

type OptimizationActionsDropdownProps = {
	rules: FilterRuleModel[]
	onApply: (rules: FilterRuleModel[]) => void
	handleExport: () => void
}

export const OptimizationActionsDropdown = ({
	rules,
	onApply,
	handleExport,
}: OptimizationActionsDropdownProps) => {
	const { t } = useTranslation()

	const popover = useDisclosure()

	return (
		<Popover
			onOpenChange={(open) => (open ? popover.open() : popover.close())}
			open={popover.isOpen}
		>
			<PopoverTrigger asChild>
				<Button>
					{t('optimization_actions_button.title', {
						defaultValue: 'Optimization actions',
					})}
					<ChevronDownIcon className='text-muted-foreground opacity-50' />
				</Button>
			</PopoverTrigger>
			<PopoverContent
				side='bottom'
				align='end'
				className='bg-card/50 p-0 backdrop-blur-2xl [--radius:1rem]'
			>
				<OptimizationsActions
					close={popover.close}
					onApply={onApply}
					rules={rules}
					handleExport={handleExport}
				/>
			</PopoverContent>
		</Popover>
	)
}
